module.exports = __webpack_public_path__ + "static/media/rugrats-player-login-logo.7dbdb0f6.png";